// extracted by mini-css-extract-plugin
export var bodyGrid = "MenuButton-module--body-grid--36e4e";
export var centerAlignedBody = "MenuButton-module--centerAlignedBody--33b46";
export var menuContainer = "MenuButton-module--menu-container--5fc7c";
export var sectionGrid = "MenuButton-module--sectionGrid--7b032";
export var sectionGridAlignCenter = "MenuButton-module--sectionGridAlignCenter--666c8";